<template>
  <div class="login-page">
    <div class="login-container">
      <!-- Logo区域 -->
      <div class="logo-section">
        <img src="@/assets/logo (2).png" alt="甜筒星球" class="logo-img" />
        <p class="logo-slogan">发现精彩直播，分享美好生活</p>
      </div>

      <!-- 登录/注册表单 -->
      <div class="form-section">
        <!-- 切换标签 -->
        <div class="form-tabs">
          <span 
            :class="['tab-item', { active: activeTab === 'login' }]" 
            @click="activeTab = 'login'"
          >登录</span>
          <span 
            :class="['tab-item', { active: activeTab === 'register' }]" 
            @click="activeTab = 'register'"
          >注册</span>
        </div>

        <!-- 登录表单 -->
        <div v-if="activeTab === 'login'" class="form-content">
          <div class="input-group">
            <input 
              v-model="loginForm.username" 
              type="text" 
              placeholder="请输入用户名/手机号"
              class="form-input"
              @blur="validateLoginUsername"
            />
            <span class="error-msg" v-if="errors.loginUsername">{{ errors.loginUsername }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="loginForm.password" 
              type="password" 
              placeholder="请输入密码"
              class="form-input"
              @blur="validateLoginPassword"
            />
            <span class="error-msg" v-if="errors.loginPassword">{{ errors.loginPassword }}</span>
          </div>
          <div class="form-options">
            <label class="remember-me">
              <input type="checkbox" v-model="loginForm.remember" />
              <span>记住我</span>
            </label>
            <a href="javascript:void(0)" class="forgot-link" @click="showForgotDialog">忘记密码?</a>
          </div>
          <button class="submit-btn" @click="handleLogin">登录</button>
        </div>

        <!-- 注册表单 -->
        <div v-else class="form-content">
          <div class="input-group">
            <input 
              v-model="registerForm.username" 
              type="text" 
              placeholder="请输入用户名(2-20位字母数字)"
              class="form-input"
              @blur="validateUsername"
            />
            <span class="error-msg" v-if="errors.username">{{ errors.username }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="registerForm.name" 
              type="text" 
              placeholder="请输入真实姓名"
              class="form-input"
              @blur="validateName"
            />
            <span class="error-msg" v-if="errors.name">{{ errors.name }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="registerForm.sfz" 
              type="text" 
              placeholder="请输入身份证号"
              class="form-input"
              @blur="validateSfz"
            />
            <span class="error-msg" v-if="errors.sfz">{{ errors.sfz }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="registerForm.phone" 
              type="text" 
              placeholder="请输入手机号"
              class="form-input"
              @blur="validatePhone"
            />
            <span class="error-msg" v-if="errors.phone">{{ errors.phone }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="registerForm.password" 
              type="password" 
              placeholder="请设置密码(6-20位字母数字)"
              class="form-input"
              @blur="validatePassword"
            />
            <span class="error-msg" v-if="errors.password">{{ errors.password }}</span>
          </div>
          <div class="input-group">
            <input 
              v-model="registerForm.confirmPassword" 
              type="password" 
              placeholder="请确认密码"
              class="form-input"
              @blur="validateConfirmPassword"
            />
            <span class="error-msg" v-if="errors.confirmPassword">{{ errors.confirmPassword }}</span>
          </div>
          <!-- 图形验证码 -->
          <div class="input-group verify-group">
            <input 
              v-model="registerForm.verifyCode" 
              type="text" 
              placeholder="请输入图形验证码"
              class="form-input verify-input"
              @blur="validateVerifyCode"
              maxlength="4"
            />
            <div class="captcha-box" @click="refreshCaptcha">
              <canvas ref="captchaCanvas" width="100" height="40" class="captcha-canvas"></canvas>
            </div>
          </div>
          <span class="error-msg" v-if="errors.verifyCode">{{ errors.verifyCode }}</span>
          <div class="agreement">
            <label>
              <input type="checkbox" v-model="registerForm.agree" />
              <span>我已阅读并同意</span>
            </label>
            <a href="#/xieyi" target="_blank">用户协议</a>
            <span>和</span>
            <a href="#/yinsi" target="_blank">隐私政策</a>
          </div>
          <span class="error-msg" v-if="errors.agree">{{ errors.agree }}</span>
          <button class="submit-btn" @click="handleRegister">注册</button>
        </div>
      </div>

      <!-- 返回首页 -->
      <div class="back-home">
        <router-link to="/">← 返回首页</router-link>
      </div>
    </div>

    <!-- 忘记密码弹窗 -->
    <div v-if="showForgot" class="dialog-overlay" @click.self="showForgot = false">
      <div class="dialog-content">
        <h3>找回密码</h3>
        <p>请联系客服重置密码</p>
        <p>客服电话: 400-123-4567</p>
        <button class="dialog-btn" @click="showForgot = false">知道了</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'LoginPage',
  data() {
    return {
      activeTab: 'login',
      showForgot: false,
      // 图形验证码
      captchaCode: '',
      loginForm: {
        username: '',
        password: '',
        remember: false
      },
      registerForm: {
        username: '',
        name: '',
        sfz: '',
        phone: '',
        password: '',
        confirmPassword: '',
        verifyCode: '',
        agree: false
      },
      errors: {
        loginUsername: '',
        loginPassword: '',
        username: '',
        name: '',
        sfz: '',
        phone: '',
        password: '',
        confirmPassword: '',
        verifyCode: '',
        agree: ''
      }
    }
  },
  
  watch: {
    // 切换到注册页时刷新验证码
    activeTab(newVal) {
      if (newVal === 'register') {
        this.$nextTick(() => {
          this.refreshCaptcha()
        })
      }
    }
  },

  methods: {
    // 生成图形验证码
    refreshCaptcha() {
      this.$nextTick(() => {
        const canvas = this.$refs.captchaCanvas
        if (!canvas) return
        
        const ctx = canvas.getContext('2d')
        const width = 100
        const height = 40
        
        // 清空画布
        ctx.fillStyle = '#f0f0f0'
        ctx.fillRect(0, 0, width, height)
        
        // 生成4位随机验证码
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
        let code = ''
        for (let i = 0; i < 4; i++) {
          code += chars[Math.floor(Math.random() * chars.length)]
        }
        this.captchaCode = code
        
        // 绘制干扰线
        for (let i = 0; i < 5; i++) {
          ctx.strokeStyle = `rgb(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255})`
          ctx.beginPath()
          ctx.moveTo(Math.random() * width, Math.random() * height)
          ctx.lineTo(Math.random() * width, Math.random() * height)
          ctx.stroke()
        }
        
        // 绘制验证码文字
        for (let i = 0; i < 4; i++) {
          ctx.font = 'bold 24px Arial'
          ctx.fillStyle = `rgb(${Math.random() * 100},${Math.random() * 100},${Math.random() * 100})`
          ctx.textBaseline = 'middle'
          // 添加旋转
          const angle = (Math.random() - 0.5) * 0.4
          ctx.save()
          ctx.translate(20 + i * 20, height / 2)
          ctx.rotate(angle)
          ctx.fillText(code[i], 0, 0)
          ctx.restore()
        }
        
        // 绘制干扰点
        for (let i = 0; i < 30; i++) {
          ctx.fillStyle = `rgb(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255})`
          ctx.beginPath()
          ctx.arc(Math.random() * width, Math.random() * height, 1, 0, 2 * Math.PI)
          ctx.fill()
        }
      })
    },
    
    // 正则验证规则
    validateName() {
      if (!this.registerForm.name) {
        this.errors.name = '请输入真实姓名'
        return false
      }
      this.errors.name = ''
      return true
    },
    validateSfz() {
      const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!this.registerForm.sfz) {
        this.errors.sfz = '请输入身份证号'
        return false
      } else if (!reg.test(this.registerForm.sfz)) {
        this.errors.sfz = '请输入正确的身份证号'
        return false
      }
      this.errors.sfz = ''
      return true
    },
    validateUsername() {
      const reg = /^[a-zA-Z0-9]{2,20}$/
      if (!this.registerForm.username) {
        this.errors.username = '请输入用户名'
        return false
      } else if (!reg.test(this.registerForm.username)) {
        this.errors.username = '用户名需为2-20位字母或数字'
        return false
      }
      this.errors.username = ''
      return true
    },
    validatePhone() {
      const reg = /^1[3-9]\d{9}$/
      if (!this.registerForm.phone) {
        this.errors.phone = '请输入手机号'
        return false
      } else if (!reg.test(this.registerForm.phone)) {
        this.errors.phone = '请输入正确的11位手机号'
        return false
      }
      this.errors.phone = ''
      return true
    },
    validatePassword() {
      const reg = /^[a-zA-Z0-9]{6,20}$/
      if (!this.registerForm.password) {
        this.errors.password = '请输入密码'
        return false
      } else if (!reg.test(this.registerForm.password)) {
        this.errors.password = '密码需为6-20位字母或数字'
        return false
      }
      this.errors.password = ''
      return true
    },
    validateConfirmPassword() {
      if (!this.registerForm.confirmPassword) {
        this.errors.confirmPassword = '请确认密码'
        return false
      } else if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.errors.confirmPassword = '两次输入的密码不一致'
        return false
      }
      this.errors.confirmPassword = ''
      return true
    },
    validateVerifyCode() {
      if (!this.registerForm.verifyCode) {
        this.errors.verifyCode = '请输入图形验证码'
        return false
      } else if (this.registerForm.verifyCode.toUpperCase() !== this.captchaCode) {
        this.errors.verifyCode = '验证码错误，请重新输入'
        return false
      }
      this.errors.verifyCode = ''
      return true
    },
    validateLoginUsername() {
      if (!this.loginForm.username) {
        this.errors.loginUsername = '请输入用户名或手机号'
        return false
      }
      this.errors.loginUsername = ''
      return true
    },
    validateLoginPassword() {
      if (!this.loginForm.password) {
        this.errors.loginPassword = '请输入密码'
        return false
      } else if (this.loginForm.password.length < 6) {
        this.errors.loginPassword = '密码长度不能少于6位'
        return false
      }
      this.errors.loginPassword = ''
      return true
    },
    showForgotDialog() {
      this.showForgot = true
    },
    handleLogin() {
      const validUsername = this.validateLoginUsername()
      const validPassword = this.validateLoginPassword()
      
      if (!validUsername || !validPassword) {
        return
      }
      
      axios.get('https://ttxq.xiangyouhulian.cn/api/index/login', {
        params: {
          username: this.loginForm.username,
          password: this.loginForm.password
        }
      }).then(response => {
        const data = response.data
        console.log('登录响应:', data)
        
        if (data.code === 1 || data.status === 1 || data.success === true) {
          // 登录成功
          alert('登录成功！')
          // 存储到本地浏览器
          localStorage.setItem('TTxq', JSON.stringify(data.data || data))
          // 存储到 Vuex
          this.$store.commit('LoginModification', data.data || data)
          // 跳转到首页
          this.$router.push('/');
        } else {
          // 登录失败
          alert(data.msg || data.message || '登录失败，请检查用户名和密码')
        }
      }).catch(error => {
        console.error('登录错误:', error)
        alert('网络错误，请稍后重试')
      })
    },
    handleRegister() {
      const valid = this.validateUsername() && 
                    this.validateName() && 
                    this.validateSfz() && 
                    this.validatePhone() && 
                    this.validatePassword() && 
                    this.validateConfirmPassword() && 
                    this.validateVerifyCode()
      
      if (!valid) {
        return
      }
      
      if (!this.registerForm.agree) {
        this.errors.agree = '请同意用户协议和隐私政策'
        return
      }
      this.errors.agree = ''
      console.log('注册表单数据:', this.registerForm)
      axios.post('https://ttxq.xiangyouhulian.cn/api/index/register', {
        username: this.registerForm.username,
        name: this.registerForm.name,
        sfz: this.registerForm.sfz,
        phone: this.registerForm.phone,
        password: this.registerForm.password
      }).then(response => {
        const data = response.data
        console.log('注册响应:', data)
        
        if (data.code === 1 || data.status === 1 || data.success === true) {
          // 注册成功
          alert('注册成功！请登录')
          this.activeTab = 'login'
          // 清空注册表单
          this.registerForm = {
            username: '',
            name: '',
            sfz: '',
            phone: '',
            password: '',
            confirmPassword: '',
            verifyCode: '',
            agree: false
          }
          // 刷新验证码
          this.refreshCaptcha()
        } else {
          // 注册失败
          alert(data.msg || data.message || '注册失败，请稍后重试')
          // 刷新验证码
          this.refreshCaptcha()
        }
      }).catch(error => {
        console.error('注册错误:', error)
        alert('网络错误，请稍后重试')
        // 刷新验证码
        this.refreshCaptcha()
      })
    },

  }
}
</script>

<style scoped lang="scss">
.login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #FBFAFF 0%, #F3F0FF 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-container {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(138, 63, 252, 0.15);
  padding: 40px;
}

/* Logo区域 */
.logo-section {
  text-align: center;
  margin-bottom: 32px;

  .logo-img {
    width: 160px;
    height: auto;
    object-fit: contain;
    margin-bottom: 16px;
  }

  .logo-text {
    font-size: 24px;
    font-weight: 600;
    color: #8A3FFC;
    margin-bottom: 8px;
  }

  .logo-slogan {
    font-size: 14px;
    color: #9B8DC7;
  }
}

/* 标签切换 */
.form-tabs {
  display: flex;
  margin-bottom: 24px;
  border-bottom: 2px solid #F0F0FF;

  .tab-item {
    flex: 1;
    text-align: center;
    padding: 12px 0;
    font-size: 16px;
    color: #9B8DC7;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;

    &:hover {
      color: #8A3FFC;
    }

    &.active {
      color: #8A3FFC;
      font-weight: 500;

      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 40px;
        height: 3px;
        background: #8A3FFC;
        border-radius: 2px;
      }
    }
  }
}

/* 表单内容 */
.form-content {
  .input-group {
    margin-bottom: 8px;

    .form-input {
      width: 100%;
      padding: 14px 16px;
      border: 1px solid #E0D5FF;
      border-radius: 12px;
      font-size: 14px;
      color: #4B3B73;
      background: #FAF8FF;
      transition: all 0.3s ease;
      box-sizing: border-box;

      &::placeholder {
        color: #9B8DC7;
      }

      &:focus {
        outline: none;
        border-color: #8A3FFC;
        background: #fff;
      }
    }
  }

  .error-msg {
    display: block;
    font-size: 12px;
    color: #ff4d4f;
    margin-bottom: 8px;
    padding-left: 4px;
  }

  .verify-group {
    display: flex;
    gap: 12px;

    .verify-input {
      flex: 1;
    }

    .captcha-box {
      width: 100px;
      height: 40px;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      border: 1px solid #E0D5FF;
      
      &:hover {
        opacity: 0.9;
      }
      
      .captcha-canvas {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
}

/* 登录选项 */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .remember-me {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #666;
    cursor: pointer;

    input {
      width: 16px;
      height: 16px;
      accent-color: #8A3FFC;
    }
  }

  .forgot-link {
    font-size: 13px;
    color: #8A3FFC;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  padding: 14px 0;
  background: linear-gradient(135deg, #8A3FFC 0%, #A855F7 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
}

/* 协议 */
.agreement {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin: 16px 0;
  font-size: 13px;
  color: #666;

  input {
    width: 16px;
    height: 16px;
    accent-color: #8A3FFC;
  }

  a {
    color: #8A3FFC;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 返回首页 */
.back-home {
  text-align: center;
  margin-top: 24px;

  a {
    font-size: 14px;
    color: #9B8DC7;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #8A3FFC;
    }
  }
}

/* 忘记密码弹窗 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dialog-content {
  background: #fff;
  padding: 32px;
  border-radius: 16px;
  text-align: center;
  min-width: 280px;

  h3 {
    font-size: 18px;
    color: #333;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }

  .dialog-btn {
    margin-top: 20px;
    padding: 10px 32px;
    background: #8A3FFC;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>